(ns reagent-form.components.field-hint
  (:require [clojure.string :as str]
            [reagent-form.utils :refer [get-field-hints
                                        get-field-hint-attrs
                                        get-field-errors
                                        field-hidden?]]))

(defn styled-hint [{:keys [mounted-node hint-idx hint class-idx class]}]
  (if (some? class)
    (-> mounted-node
        (assoc-in [hint-idx] hint)
        (update-in [class-idx :class] str " " class))
    (assoc-in mounted-node [hint-idx] hint)))

(defn mount-field-hint
  [{:keys [node form-state]}]
  (let [params
        (second node)

        {:keys [field-key]}
        (:rf/field-hint params)

        mounted-node
        (assoc-in node [1]
                  (-> params
                      (dissoc :rf/field-hint)))]
    (fn []
      (let [hint (first (get-field-hints @form-state field-key))
            hint-class (-> (get-field-hint-attrs @form-state field-key hint)
                           :class)
            hint-default-position? (-> (get-field-hint-attrs @form-state field-key hint)
                                       :position-under-field?
                                       not)
            hint-markup-default? (-> (get-in mounted-node [1 :class])
                                     (str/includes? "below")
                                     not)
            error (first (get-field-errors @form-state field-key))
            hidden (field-hidden? @form-state field-key)]
        (when (and hint
                   (not error)
                   (not hidden)
                   (or (and hint-default-position? hint-markup-default?)
                       (and (not hint-default-position?) (not hint-markup-default?))))
          [styled-hint {:mounted-node mounted-node
                        :hint-idx 2
                        :hint hint
                        :class-idx 1
                        :class hint-class}])))))
